import { PrefixData } from "src/interfaces/prefix-data";
import { QuestionTypeTrpComponent } from "./components/question-type-trp/question-type-trp.component";
import { QuestionTypeUppComponent } from "./components/question-type-upp/question-type-upp.component";

export const QUESTION_TYPE_DATA: PrefixData = {
  "question-type-trp": { class: QuestionTypeTrpComponent, inputs: { required: "required" } },
  "question-type-upp": { class: QuestionTypeUppComponent, inputs: { required: "required", unitPrice: "unitPrice" } },
};
